import { createSelector } from 'reselect';

import { getListingAliasFromPath } from '../utils/pathUtils';

type State = {
  router: {
    location: {
      search: string;
      pathname: string;
    };
  };
};

export const getRouting = (state: State) => state.router;

const getLocation = (state: State) => getRouting(state).location;

const RoutingSelectors = {
  makeRouting: createSelector([getRouting], (router) => router),
  makeLocation: createSelector([getLocation], (location) => location),
  makeSearch: createSelector([getLocation], (location) => location.search),
  makePathname: createSelector([getLocation], (location) => location.pathname),
  makeListingId: createSelector([getLocation], (location) => getListingAliasFromPath(location.pathname)),
};

export default RoutingSelectors;
